import { useTitle } from './useTitle';

export const useTitleTemplate = (template: string) => {
  useTitle(template, true);
};
